export const OUTSCHOOL_ENV = process?.env?.OUTSCHOOL_ENV ?? "development";
export const IS_REVIEW_APP = process?.env?.IS_REVIEW_APP === "true";
